import React from 'react';
import {Video} from 'lucide-react';
import RenderIf from "@/components/render-if";
import FileViewer from "@/lib/helper/FileViewer";

function StudentMyLessonBookResourceSection({data}) {

    if(!data?.data?.data?.lesson?.topic?.contents?.length)
    {
        return null;
    }

    return (
        <>
            {/* Educational Resources */}
            <div className="rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-600">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-emerald-100 rounded-lg">
                        <Video className="w-6 h-6 text-emerald-600"/>
                    </div>
                    <h2 className="text-2xl font-bold ">منابع آموزشی</h2>
                </div>

                <div className="grid grid-cols-1 gap-4">
                    {data?.data?.data?.lesson?.topic?.contents?.length > 0 && data?.data?.data?.lesson?.topic?.contents?.map((resource) => (
                        <div
                            key={resource.id}

                            className="group flex items-center gap-4 p-4 border dark:border-gray-600 rounded-xl hover:shadow-md
                             transition-all duration-200 hover:border-blue-300"
                        >

                            <div className="flex-1">
                                <h3 className="font-medium  group-hover:text-blue-600 transition-colors">{resource.title}</h3>
                                <p>{resource.content}</p>
                                <RenderIf condition={!!resource?.file?.url}>
                                    <div className={'my-1'}>
                                        <FileViewer fileUrl={resource?.file?.url} />
                                    </div>
                                </RenderIf>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
        </>

    );
}

export default StudentMyLessonBookResourceSection;